import type { Components, Theme } from "@mui/material";

export const skeletonTheme: Components<Theme>["MuiSkeleton"] = {
  styleOverrides: {
    rounded: {
      borderRadius: "18px",
    },
  },
};
